import { render, staticRenderFns } from "./EditAuthorPopup1.vue?vue&type=template&id=085718e3"
import script from "./EditAuthorPopup1.vue?vue&type=script&lang=js"
export * from "./EditAuthorPopup1.vue?vue&type=script&lang=js"
import style0 from "./EditAuthorPopup1.vue?vue&type=style&index=0&id=085718e3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports